import {EVM_NETWORKS} from 'src/types';
import type {Wallet} from '@stripe-internal/wallet-connect-wrapper';
import type {SupportedCurrency} from 'src/v2/state/types';

export const getWalletNetworkSupport = (
  wallet: Wallet,
  supportedCurrencies: SupportedCurrency[],
): 'supported' | 'network_type_supported' | 'not_supported' => {
  const supportedNetworks = [
    ...new Set(supportedCurrencies.map((currency) => currency.currencyNetwork)),
  ];

  if (supportedNetworks.includes(wallet.network)) {
    return 'supported';
  }

  // Check if wallet's network type is supported
  if (wallet.network === 'solana') {
    return 'not_supported';
  }

  // For EVM networks, check if any EVM network is supported
  const supportedEvmNetworks = supportedNetworks.filter((network) =>
    EVM_NETWORKS.includes(network),
  );

  return supportedEvmNetworks.length > 0
    ? 'network_type_supported'
    : 'not_supported';
};
